import { Component, OnInit } from '@angular/core';
import { CurrencyMaskInputMode } from 'ngx-currency';
import { KycService } from 'src/app/shared/services/kyc.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { FundingService } from 'src/app/shared/services/funding.service';

@Component({
    selector: 'app-withdraw',
    templateUrl: './withdraw.component.html',
    styleUrls: ['./withdraw.component.scss'],
})
export class WithdrawComponent implements OnInit {
    amount: number;
    fundIndex: number = 1;
    activeMethod: number;
    isSuccess: boolean;
    isProcessing: boolean;
    usdPending: number;
    validation: boolean = false;

    currencyOptions = {
        align: 'left',
        allowNegative: false,
        allowZero: false,
        decimal: '.',
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: ',',
        nullable: true,
        min: null,
        max: null,
        inputMode: CurrencyMaskInputMode.NATURAL,
    };
    fundMethods = [
        {
            name: 'Bank Account',
            logo: '',
            active: true,
            id: 1,
        },
        {
            name: 'Trading Wallet',
            logo: '',
            active: false,
            id: 2,
        },
    ];
    bank: any;
    wallet: any;
    ngnBalance: number;
    usdBalance: number;
    accountName: string;
    accountNo: string;
    accountExist: boolean = true;
    bankName: string;
    accountNumber: string;
    model: any = {};
    actSuccess: boolean = false;
    fullName: string;
    processed: boolean = false;

    // Computed Properties
    get showBackButton() {
        return this.fundIndex > 1;
    }

    // Methods

    switchMethod(item) {
        if (!item.active) return false;
        this.activeMethod = item.id;
        this.nextFunding();
    }

    nextFunding() {
        console.log(this.fundIndex)

        if (this.fundIndex === 1) {
            // console.log(this.amount)

            // if(this.amount == undefined){
            // TODO: refactor this check, wierd logic
            // if(this.amount == undefined || this.amount == 0 || this.amount > this.usdBalance){
            if (this.amount == undefined || this.amount == 0) {
                if (this.amount <= 0 || this.amount == undefined) {
                    this.toastr.error('Zero Amount', 'Amount cannot be zero', {
                        timeOut: 5000,
                        positionClass: 'toast-top-center'

                    });
                }


                // else if(this.usdPending != 0 && this.amount > this.usdBalance){
                //     // console.log(this.amount)
                //     this.toastr.error('Funds still being processed','You seem to have unsettled cash in your wallet.Kindly wait till funds have been processed',{
                //         timeOut:5000,
                //         positionClass: 'toast-top-center'

                //     });
                // }

                // else if(this.amount > this.usdBalance){
                //     if(this.usdPending != 0 && this.amount <= this.usdBalance){
                //         console.log(this.amount)
                //         this.toastr.error('Funds still being processed','You seem to have unsettled cash in your wallet.Kindly wait till funds have been processed',{
                //             timeOut:5000,
                //             positionClass: 'toast-top-center'

                //         });
                //     }
                //     else
                //     this.toastr.error('Insufficient Fund',' Wallet balance is lesser than amount entered',{
                //         timeOut:5000,
                //         positionClass: 'toast-top-center'

                //     });
                // }

            }
            else {

                this.fundIndex += 1;
                if (this.fundIndex === 5) {
                    this.isSuccess = false;
                }
            }
        }
        else if (this.fundIndex === 4 && this.processed === false) {
            this.withdrawFund()
        }

        else {
            this.fundIndex += 1;
        }



    }

    goBackFunding() {
        this.accountExist = true;
        if (this.fundIndex > 1) this.fundIndex -= 1;
    }


    constructor(private route: Router,
        private router: ActivatedRoute,
        private SpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private withdraw: KycService,
        private fund: FundingService,) { }

    ngOnInit() {
        this.getBank();
        this.getWallet();
        this.getProfile();
    }

    getBank() {
        this.withdraw.getBank()
            .subscribe((res: any) => {
                this.bank = res.data;
            })
    }

    getWallet() {
        this.SpinnerService.show();
        this.withdraw.getWallet('')
            .subscribe((res: any) => {
                this.wallet = res.data;
                let ngnWallet = this.wallet.filter(ngn => ngn.provider == 'IW');
                this.ngnBalance = ngnWallet[0].availableToWithdraw;
                let usdWallet = this.wallet.filter(usd => usd.provider == 'DW');
                this.usdBalance = usdWallet[0].availableToWithdraw;
                this.usdPending = usdWallet[0].pendingCash;
                this.SpinnerService.hide();
            }, err => {
                this.SpinnerService.hide();
            })
    }

    getProfile() {
        this.withdraw.getProfile()
            .subscribe((res: any) => {
                this.accountName = res.data.bankAcctName;
                this.accountNo = res.data.bankAcctNo;
                this.fullName = res.data.fullName;

            })
    }

    updateAcct() {
        if (this.model.accountNumber == undefined) {

            this.validation = false;
        }
        else {
            this.SpinnerService.show();
            this.withdraw.updateAccountInfo(this.fullName, this.model.accountNumber, this.model.bankName)
                .subscribe((res: any) => {
                    console.log(res)
                    if (res.message = 'Successful') {
                        this.accountNo = res.data.bankAcctNo;
                        this.actSuccess = true;
                        this.SpinnerService.hide();
                    }

                }, err => {
                    this.SpinnerService.hide();
                    this.validation = true;
                    this.toastr.error(err.message, 'We could not update your new account', {
                        timeOut: 5000,
                        positionClass: 'toast-top-center'

                    });
                })
            this.nextFunding()

        }

    }

    change() {
        this.accountExist = false;
    }

    withdrawFund() {
        this.SpinnerService.show();
        //first leg of withdrawal
        //TODO: Payout Account leg left
        this.fund.CreateRedemption(this.amount)
            .subscribe((res: any) => {
                console.log(res)
                if (res.code == 200) {
                    // TODO: Call payout Account leg.
                    this.isSuccess = true;
                    this.processed = true;
                    this.nextFunding();
                    this.SpinnerService.hide();
                }
                else {
                    this.processed = true;
                    this.SpinnerService.hide();
                    this.toastr.error('Something went wrong.Please try again', 'Withdrawal Error', {
                        timeOut: 5000,
                        positionClass: 'toast-top-center'

                    });
                }
            }, err => {
                this.processed = true;
                this.SpinnerService.hide();
                this.isSuccess = false;
                this.toastr.error(err.message, 'Withdrawal Error', {
                    timeOut: 5000,
                    positionClass: 'toast-top-center'

                });
            })
    }
}
